// extracted by mini-css-extract-plugin
export default {"textCard":"TextCard_textCard__G9Qro","transparentCard":"TextCard_transparentCard__CtrEa"};